export default {"src":"/_next/static/media/no_opponent.6bbd05a0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};